<template>
    <v-card class="mt-3 shop-product-supplies" :disabled="disabled">
        <v-card-title>
            <v-row>
                <v-col class="subtitle-1 py-0">보임처리 (숨김/보임)</v-col>
                <v-col md="auto" sm="auto" class="py-0">
                    <v-switch v-model="display" dense hide-details class="mt-0" @change="input"></v-switch>
                </v-col>
            </v-row>
        </v-card-title>
    </v-card>
</template>

<script>
export default {
    props: {
        disabled: { type: Boolean, default: false },
        value: { type: Object, default: null },
    },
    data: () => {
        return {
            display: false,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                var { display } = this.value;

                if (display === undefined) display = this.display;

                Object.assign(this.$data, {
                    display,
                });
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
        input() {
            this.$set(this.value, "display", this.display);

            this.$emit("input", this.value);
        },
    },
    watch: {
        value() {
            this.init();
        },
    },
};
</script>
